import { useWatchableValue } from '@cotera/client/v0/actions/framework/watchable';
import { Textarea } from '@cotera/client/v0/components/ui/textarea';
import { useColumnModel } from '../context';
import { useTextFieldTracking } from '@cotera/client/app/etc';

export const SystemMessage: React.FC = () => {
  const model = useColumnModel();
  const { systemMessage: systemPrompt } = useWatchableValue(model.formState);
  const trackChange = useTextFieldTracking('LLM System Message Typed');

  return (
    <div className="flex flex-col gap-2 w-full h-full py-2 px-1">
      <div className="text-sm text-foreground/50 py-2">System message</div>
      <div className="flex flex-col h-full">
        <Textarea
          className="flex-1 min-h-0 overflow-y-auto resize-none"
          value={systemPrompt}
          onChange={(v) => {
            const newValue = v.target.value;
            model.formState.set({
              ...model.formState.snapshot(),
              systemMessage: newValue,
            });
            trackChange(newValue);
          }}
        />
      </div>
    </div>
  );
};
